<template>
  <div class="group">
    <b-row>
    <b-list-group>
      <b-list-group-item style="text-align: center; font-size: 16px;">
        <strong>Groups</strong>
      </b-list-group-item>
      <b-list-group-item style="text-align: center; color: #9f5d6b !important; font-size: 16px;">
        <strong>Group Name</strong>
      </b-list-group-item>
      <b-list-group-item class="bg-w" @click="$bvModal.show('save-group-modal')"><img src="img/filterblue.gif" /> acc</b-list-group-item>
      <b-list-group-item class="bg-g" @click="$bvModal.show('save-group-modal')"><img src="img/filterblue.gif" /> bbbbb</b-list-group-item>
      <b-list-group-item class="bg-w" @click="$bvModal.show('save-group-modal')"><img src="img/filterblue.gif" /> ddddrrr</b-list-group-item>
      <b-list-group-item class="bg-g" @click="$bvModal.show('save-group-modal')"><img src="img/filterblue.gif" /> pr-main</b-list-group-item>
      <b-list-group-item class="bg-w" @click="$bvModal.show('save-group-modal')"><img src="img/filterblue.gif" /> TestGroup</b-list-group-item>
      <b-list-group-item v-if="groupsArr.length > 0" class="bg-w" @click="$bvModal.show('save-group-modal')"><img src="img/filterblue.gif" /> {{groupsArr[0]}}</b-list-group-item>
    </b-list-group>
  </b-row>

<b-modal id="save-group-modal" size="lg" hide-footer>
    <template #modal-title>
      <img class="ielogo" src="img/ielogo.png" /> .. -
      <strong>Microsoft Internet Explorer</strong>
      <div class="toolicons">
      <i @click="$bvModal.hide('save-group-modal')" data-v-056ee09c="" aria-label="icon: underline" class="anticon anticon-underline"><svg viewBox="64 64 896 896" data-icon="underline" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1"></path></svg></i>
      <i data-v-056ee09c="" aria-label="icon: play-square" class="anticon anticon-play-square"><svg viewBox="64 64 896 896" data-icon="play-square" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path></svg></i>
      <a-icon type="close" @click="$bvModal.hide('save-group-modal')" />
    </div>
    </template>
    
    <div class="d-block text-center">
      <div class="tableDiv">
      <div class="table-header" style="text-align: center">
        <span class="tableheading">Group : PurchaseRequisitionView</span> 
      </div>
      <div class="table-body">
        <b-row>
          <b-col class="firstcol">
            Column Names For Grouping :<br>
          <a-checkbox @change="onChange">
            Pur Requisition No
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Pur Requisition Date
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Pur Requisition Type
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Ref No
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Authorized
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Authorization Stage
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Cancel Rejection
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Total Estimated Cost
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Remarks
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Document Status
          </a-checkbox>
          </b-col>
          <b-col>
            <a-form>
              <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
                  label="GroupName : "
                >
                  <a-input
                    v-model="groupName"
                    placeholder=""
                  />
                </a-form-item>
                <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
                  label="GroupDescription : "
                >
                  <a-textarea
                    style="border: 2px inset;"
                    placeholder=""
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                  />
                </a-form-item>
            </a-form><br>
            <b-button class="glass" @click="saveGroup()">Save Group</b-button>
          </b-col>
        </b-row>
      </div>
    </div>
    </div>
  </b-modal>

<b-modal id="group-modal" size="xl" hide-footer>
    <template #modal-title>
      <img class="ielogo" src="img/ielogo.png" /> .. -
      <strong>Microsoft Internet Explorer</strong>
      <div class="toolicons">
      <i @click="$bvModal.hide('group-modal')" data-v-056ee09c="" aria-label="icon: underline" class="anticon anticon-underline"><svg viewBox="64 64 896 896" data-icon="underline" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1"></path></svg></i>
      <i data-v-056ee09c="" aria-label="icon: play-square" class="anticon anticon-play-square"><svg viewBox="64 64 896 896" data-icon="play-square" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path></svg></i>
      <a-icon type="close" @click="$bvModal.hide('group-modal')" />
    </div>
    </template>
    
    <div class="d-block text-center">
      <div class="tableDiv">
      <div class="table-header" style="text-align: center">
        <span class="tableheading">Group : PurchaseRequisitionView</span> 
      </div>
      <div class="table-body">
        <b-row>
          <b-col class="firstcol">
            Column Names For Grouping :<br>
          <a-checkbox @change="onChange">
            Pur Requisition No
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Pur Requisition Date
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Pur Requisition Type
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Ref No
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Authorized
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Authorization Stage
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Cancel Rejection
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Total Estimated Cost
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Remarks
          </a-checkbox><br>
          <a-checkbox @change="onChange">
            Document Status
          </a-checkbox>
          </b-col>
          <b-col>
            <a-form>
              <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
                  label="GroupName : "
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
            </a-form><br>
            <b-row class="group-btn">
              <b-button class="glass">Execute Group</b-button>
            <b-button class="green-glass">Save Changes</b-button>
            <b-button class="glass">Delete Group</b-button>
            </b-row><br>
            <p style="text-align: left; padding-left: 75px;">Changes saved.</p>
          </b-col>
        </b-row>
      </div>
    </div>
    </div>
  </b-modal>

  </div>
</template>

<script>
export default {
  name: 'GroupNav',
  data() {
      return {
        groupName: '',
        groupsArr: [],
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
      }
    },
    methods: {
      onChange(e) {
          this.checked = e.target.checked;
        },
      saveGroup(){
        const groups = []
        groups.push(this.groupName)
        localStorage.setItem('groups', JSON.stringify(groups))
        const groupsFromLocalStorage = localStorage.getItem('groups')
        if (groupsFromLocalStorage && groupsFromLocalStorage.length) {
          this.groupsArr = JSON.parse(groupsFromLocalStorage)
        this.$root.$emit("bv::hide::modal", "save-group-modal");
          return this.groupsArr
        }
      }
    }
}
</script>

<style scoped>
.group-btn{
      display: flex;
    width: 100%;
    justify-content: flex-end;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.group .list-group{
      margin-left: 25px;
    margin-top: 15px;
    border: 1px solid #333;
    width: 225px;
    padding: 0;
}
.list-group-item{
  background: transparent;
  text-align: left;
      border: 2px solid #fff;
    padding: 0rem;
    font-size: 12px;
    font-weight: 600;
}
.group .list-group-item img{
  border-right: 2px solid #fff;
    padding: 0px 25px 0px 5px;
    background: #bbc7d6;
}
.firstcol{
  text-align: left;
  padding-left: 24px;
}
.firstcol .ant-checkbox-wrapper{
  padding-left: 50px;
}
.tableDiv{
  border: 1px solid;
  margin: 20px 0px 15px 5px;
  border-radius: 5px;
  text-align: left;
}
.table-header{
  background: #bdc7d6;
  text-align: left;
  border-bottom: 1px solid;
}
.tableimg{
  padding-left: 10px;
    padding-right: 10px;
    width: 30px;
    margin-top: -4px;
}
.tableheading{
  padding-left: 10px;
      font-size: 14px;
    font-weight: 700;
}
.table-body{
      text-align: center;
    padding: 5px;
}
.table-body select, .table-body input{
  border: 2px inset;
}
.page{
  padding-top: 5px !important;
  padding-left: 15px !important;
   font-weight:500;
    font-size: 12px;
}
.ielogo{
  width: 20px;
  margin-left: 5px;
}
.toolicons{
      position: absolute;
      right: 3px;
    top: -2px;
}
.toolicons .anticon{
      background: #c0c0c0;
    border: 2px outset;
    margin-right: 2px;
    color: #333;
}
.green-glass{
  position: relative;
    display: inline-block;
        padding: 0px 15px;
    border: 0;
    background-color: green;
    background-image: linear-gradient(lightgreen,#66b266,lightgreen);
    text-decoration: none;
    color: #333;
    font-size: 14px;
    font-family: sans-serif;
    font-weight: 700;
    box-shadow: rgb(0 0 0 / 25%) 1.95px 1.95px 2.6px;
    border-radius: 15px;
    margin-right: 5px;
    max-width: 135px;
}
.glass{
position: relative;
    display: inline-block;
    padding: 0px 14px;
    border: 0;
    background-color: green;
    background-image: linear-gradient(#d8e1e9,#c1cfdc,#d8e1e9);
    text-decoration: none;
    color: #333;
    font-size: 15px;
    font-family: sans-serif;
    font-weight: 700;
    box-shadow: rgb(0 0 0 / 25%) 1.95px 1.95px 2.6px;
    border-radius: 15px;
    margin-right: 5px;
    max-width: 135px;
}
select {

  /* styling */
  background-color: white;
  border: thin solid blue;
  border-radius: 4px;
  display: inline-block;
  font: inherit;
  line-height: 1.5em;
  padding: 0em 3.5em 0em 0.5em;

  /* reset */

  margin: 0;      
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
}
select.round {
background-image: linear-gradient( 
45deg, transparent 30%, gray 74%), linear-gradient( 
135deg, gray 68%, transparent 36%), radial-gradient(#c0c0c0 100%, transparent 50%);
    background-position: calc(100% - 12px) calc(1em + -5px), calc(100% - 8px) calc(1em + -5px), calc(100% - 0em) 0em;
    background-size: 5px 5px, 5px 5px, 1.5em 1.5em;
    background-repeat: no-repeat;
    border: 2px inset;
    }
.table-body .ant-form-item{
  margin-bottom: 0;
}
.table-body .ant-form-item-label{
  text-align: left;
}
</style>
